import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes
const VERSION_KEY = 'app_build_time';

export function useVersionCheck() {
  const initialBuildTime = useRef<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store'
        });
        
        if (!response.ok) return;
        
        const data = await response.json();
        const currentBuildTime = data.buildTime;

        // First load - store the initial version
        if (!initialBuildTime.current) {
          initialBuildTime.current = currentBuildTime;
          localStorage.setItem(VERSION_KEY, currentBuildTime);
          return;
        }

        // Check if version has changed
        if (currentBuildTime !== initialBuildTime.current) {
          toast.info('Update available', {
            description: 'A new version is available. Click to refresh.',
            duration: Infinity,
            action: {
              label: 'Refresh',
              onClick: () => window.location.reload()
            }
          });
        }
      } catch (error) {
        // Silently fail - version check is non-critical
      }
    };

    // Check on mount
    checkVersion();

    // Check periodically
    const interval = setInterval(checkVersion, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);
}
